import { useEffect } from 'react'
import { Link, useRouteError } from 'react-router'
import { useTranslation } from 'react-i18next'
import { captureExceptionIfEnabled } from '@/infrastructure/sentry/sentryClient'

/**
 * Root-route ErrorBoundary that reports caught errors to Sentry when
 * the consent gate has initialized the SDK (ADR-035, S35).
 *
 * `captureExceptionIfEnabled` is a no-op when the SDK is uninitialized
 * — the consent-off path stays completely SDK-free at runtime. The
 * fallback UI renders regardless so an unauthenticated, opt-out user
 * still gets a recovery path.
 */
export function RouteErrorBoundary() {
  const error = useRouteError()
  const { t } = useTranslation()

  useEffect(() => {
    if (error !== undefined && error !== null) {
      captureExceptionIfEnabled(error)
    }
  }, [error])

  return (
    <main className="mx-auto max-w-3xl px-6 py-12 flex flex-col gap-6">
      <h1
        className="text-4xl font-medium"
        style={{ fontFamily: 'var(--font-display)' }}
      >
        {t('error.title')}
      </h1>
      <p className="text-sm" style={{ color: 'var(--color-muted)' }}>
        {t('error.body')}
      </p>
      <p className="text-sm">
        <Link to="/" className="underline" style={{ color: 'var(--color-fg)' }}>
          {t('error.backHome')}
        </Link>
      </p>
    </main>
  )
}
